module.exports = __webpack_public_path__ + "img/mary-pro.327917ce.jpg";